import { createContext } from "react";



export const AddCircleContext=createContext()